import { combineReducers } from 'redux';
import authActionsReducers from './authActionReducer';
const reducers = combineReducers({
    authActionsReducers,
})

export default reducers;